// Date helpers for the Tasks tab. The API returns dates as 'YYYY-MM-DD' strings and the store's
// locale can be 'defaultLocale' / 'zhHans' / 'zhHant', which aren't valid BCP 47 tags.

const DISPLAY_LOCALES = {
  defaultLocale: 'en-GB',
  en: 'en-GB',
  zhHans: 'zh-Hans',
  zhHant: 'zh-Hant',
};

export const displayLocale = locale => DISPLAY_LOCALES[locale] ?? locale ?? 'en-GB';

/** 'YYYY-MM-DD' → local Date at midnight (not shifted by the viewer's time zone). */
export const parseIsoDate = (value) => {
  if (!value) return null;
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

export const startOfToday = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

export const addDays = (date, days) => new Date(date.getTime() + days * 864e5);

/** Whole days from today to the given 'YYYY-MM-DD' (negative once it has passed). */
export const daysFromToday = (value) => {
  const date = parseIsoDate(value);
  if (!date) return null;
  return Math.round((date - startOfToday()) / 864e5);
};

export const formatDate = (date, locale, options) => {
  if (!date) return '–';
  try {
    return date.toLocaleDateString(displayLocale(locale), options);
  } catch {
    return date.toLocaleDateString('en-GB', options);
  }
};

/** e.g. "14 Nov" */
export const formatDayMonth = (value, locale) =>
  formatDate(parseIsoDate(value), locale, { day: 'numeric', month: 'short' });

/** e.g. "14 Nov 2026" */
export const formatDayMonthYear = (value, locale) =>
  formatDate(parseIsoDate(value), locale, { day: 'numeric', month: 'short', year: 'numeric' });

/** e.g. "14/11/2026" */
export const formatShortDate = (value, locale) =>
  formatDate(parseIsoDate(value), locale, { day: '2-digit', month: '2-digit', year: 'numeric' });

/** e.g. "Sat" */
export const formatWeekday = (date, locale) => formatDate(date, locale, { weekday: 'short' });

/** e.g. "Sat 11 Oct 14:32" */
export const formatStamp = (date, locale) => {
  if (!date) return '';
  const options = { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' };
  try {
    return date.toLocaleString(displayLocale(locale), options);
  } catch {
    return date.toLocaleString('en-GB', options);
  }
};
